// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._1fvdglyw button:not([disabled]):after{border:none}._18u0idpf{margin-left:0}\n._1e0c1txw{display:flex}\n._1ul91wug{min-width:auto}\n._1xdi1txw >span{display:flex}\n._1ylx1txw >div>div{display:flex}\n._4cvr1h6o{align-items:center}\n._p7r11txw >div{display:flex}", ""]);
// Exports
module.exports = exports;
